import cn from '@/lib/cs';
import React from 'react';

const MenuIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<path
			fill="currentColor"
			d="M15 4a3 3 0 0 1-3 3c-1.7 0-3-.5-3-3a3 3 0 0 1 3-3c1.7 0 3 1 3 3ZM15 12a3 3 0 1 1-3-3c1.5.5 3 1.3 3 3ZM15 19c0 1.7-1.3 4-3 4a3 3 0 1 1 0-6c1.7 0 3 .3 3 2Z"
		/>
	</svg>
);

export default MenuIcon;
